import React from 'react';
import { Chip, TableBody, TableCell, TableRow, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { checkPermission } from '../../utils_v2';
import {SortableContainer, SortableElement, sortableHandle} from 'react-sortable-hoc';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
const DragHandle = sortableHandle(() => <span style={{paddingRight:'10px', display:'inline-block', cursor:'move'}}><DragIndicatorIcon /></span>);
const SortableItem = SortableElement(({item, onEdit, onDelete, onView}) => 
    <TableRow>
        <TableCell align='left' style={{cursor:'pointer', position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, width:'200px'}}>
            <div style={{display:'flex', alignItems:'center', flexWrap:'nowrap'}}>
                <VisibilityIcon onClick={onView} color='primary' fontSize='small' />
                { item.custom_profile ?
                    <>
                        {checkPermission('settings', 'profile_order', 'U')?
                            <Tooltip title='Edit'><EditIcon style={{marginLeft:'8px'}} onClick={onEdit} color='primary' fontSize='small' /></Tooltip>:null
                        }
                        { checkPermission('settings', 'profile_order', 'D') ?
                             <Tooltip title='Delete'><DeleteOutlineIcon style={{marginLeft:'8px'}} onClick={onDelete} color='secondary' fontSize='small' /></Tooltip>:null
                        }
                    </>:null
                }
                {checkPermission('settings', 'profile_order', 'U') ?
                    <span style={{marginLeft:'8px'}}><DragHandle /></span>:null
                }
            </div>
        </TableCell>
        <TableCell style={{width:'10%'}}>
            {item.order}
        </TableCell>
        <TableCell style={{width:'20%'}}>
            {item.name}<br/>
            <Chip label={item.custom_profile ? 'Custom':'Default'} size='small' />
        </TableCell>
        <TableCell style={{width:'10%'}}>{item.sparta_groups.length}</TableCell>
        <TableCell style={{width:'30%'}}>{item.description}</TableCell>
        <TableCell style={{width:'20%'}}>{item?.created_by?.name||'--'}</TableCell>
    </TableRow>
);
const RoleProfile = SortableContainer(({items, onEdit, onDelete, onView}) => {
    return (
        <TableBody>
            {items.map((item, index) => (
                <SortableItem onView={() => onView(item)} onEdit={() => onEdit(item)} onDelete={() => onDelete(item)} key={`item-${index}`} sortIndex={index} index={index} item={item} />
            ))}
        </TableBody>
    );
});
export default RoleProfile;